import { Component, ElementRef, Input, AfterViewInit, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'm-btn',
    imports: [CommonModule, TranslateModule],
    templateUrl: './modern-button.component.html',
    styleUrl: './modern-button.component.scss'
})
export class ModernButtonComponent implements AfterViewInit {

  @Input() title: string = '';
  @Input() disabled: boolean = false;
  @Input() icon: string = '';
  @Input() label: string = '';
  @Input() display: 'contained' | 'outlined' | 'text' = 'contained';
  @Input() color: 'blue' | 'black' | 'green' | 'red' | 'yellow' = 'blue';
  @Input() animate: '' | 'hide-text' = '';
  @Input() styles: '' | 'rounded'  = '';
  @Input() size: 'fit' | 'stretch' = 'fit';
  @Input() fontSize: number = 14;
  
  @ViewChild('button') button!: ElementRef<HTMLButtonElement>;

  ngAfterViewInit(): void {

      setTimeout(() => {
        //So that animations don't play at the start when the component is rendered
        this.button.nativeElement.classList.add('ready');
      }, 0);
  }

  onMouseDown(event: MouseEvent): void {
    if (this.disabled) return;

    const button = event.currentTarget as HTMLElement;
    const rect = button.getBoundingClientRect();

    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    button.style.setProperty('--splash-x', x + 'px');
    button.style.setProperty('--splash-y', y + 'px');
    button.classList.remove('splash-active');

    void button.offsetWidth;

    button.classList.add('splash-active');

    const splash = button.querySelector('.splash') as HTMLElement;
    if (splash) {
      splash.addEventListener('animationend', () => {
        button.classList.remove('splash-active');
      }, { once: true });
    }
  }

}
